<template>
  <div class="app-container">
    <FaqPanel
      page="profile"
      :top-offset="50"
      :max-width="350"
      :backdrop="true"
    />
    <el-container>
      <el-main>
        <div class="tab-container">
          <el-tabs v-model="activeTab">
            <el-tab-pane
              v-for="item in tabs"
              :key="item.id"
              :label="item.title"
              :name="item.id"
            >
              <keep-alive>
                <component
                  :is="item.id"
                  v-if="activeTab === item.id"
                  @go-back="goBack"
                />
              </keep-alive>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, watch } from 'vue'
import ProfileForm from '@/components/Profile/ProfileForm.vue'
import AccountSettings from './components/AccountSettings.vue'

import { useUserStore } from '@/store/modules/user'
import useRouter from '@/hooks/useRouter'
import FaqPanel from '@/components/FaqPanel/Index.vue'

export default defineComponent({
  name: 'Profile',
  components: {
    AccountSettings,
    ProfileForm,
    FaqPanel
  },
  props: {
    tab: {
      type: String,
      default: 'ProfileForm'
    }
  },
  setup(props, context) {
    const userStore = useUserStore()
    const tabs = ref([
      {
        id: 'ProfileForm',
        title: 'Profile'
      },
      {
        id: 'AccountSettings',
        title: 'Account settings'
      }
    ])

    userStore.GetUserInfo(true)

    const { router } = useRouter()

    const activeTab = ref(props.tab)

    const goBack = () => {
      if (userStore.isProcessingOnboarding) {
        userStore.clearOnboardProcessingFlag()
      }
      router.go(-1)
    }

    watch(
      (_: any) => props.tab,
      (_) => {
        activeTab.value = props.tab
      }
    )

    return {
      tabs,
      activeTab,
      goBack
    }
  }
})
</script>

<style lang="scss" scoped>
.el-main {
  padding: 0 5px;
}
</style>
